import { render, staticRenderFns } from "./LatestUploading.vue?vue&type=template&id=53bfa12c&scoped=true&"
import script from "./LatestUploading.vue?vue&type=script&lang=js&"
export * from "./LatestUploading.vue?vue&type=script&lang=js&"
import style0 from "./LatestUploading.vue?vue&type=style&index=0&lang=less&"
import style1 from "./LatestUploading.vue?vue&type=style&index=1&id=53bfa12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfa12c",
  null
  
)

export default component.exports